import m from "../../geodata/es2015/solomonIslandsLow";
window.am4geodata_solomonIslandsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/solomonIslandsLow.js
// module id = null
// module chunks = 